import type { TRuleWithTheme } from '@/styles/theme';

export const link: TRuleWithTheme = () => ({
    marginLeft: '0.25rem',
});
